import { sidebarConfig } from '@backstage/core-components'
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const useLogoStyle = makeStyles(
  {
    container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    },
    image: {
      height: sidebarConfig.logoHeight,
      with: 'auto',
    },
    platt: {
      width: (sidebarConfig.drawerWidthOpen - 24 * 2),
      height: 12, // font size of plattText 12
      textAlign: 'right',
    },
    plattText: {
      fontSize: 12,
      color: '#318CCA',
      fontStyle: 'italic',
      fontWeight: 'bold',
    }
  }
);

const ImageLogoFull = (props: {url: string}) => {
  const classes = useLogoStyle();

  return (
  <div className={classes.container}>
    <div><img src={props.url} alt="logo" className={classes.image}  /></div>
    <div className={classes.platt}><Typography component="span" className={classes.plattText}>powered by PlaTT</Typography></div>
  </div>);
}

export default ImageLogoFull;
